<template>
   <div class="container" :class=" data.active ? '' : 'bg-danger'">
      <i>Prestador:</i>
      <div class="row border-top border-bottom">
         <div class="col-12 col-md-9 text-start">
            <i><b>{{data.name}}</b></i>
         </div>
         <div class="col-12 col-md-3 text-start text-md-end">
            <i><b>{{data.cuit}}</b></i>
         </div>
      </div>
      <i>Lugar de Atención:</i>
      <div class="row border-top border-bottom">
         <div class="col-12 col-md-10 text-start">
            <i><b>{{data.fantasyName}}</b></i>
         </div>
         <div class="col-12 col-md-2 text-start text-md-end">
            <i>ID: <b>{{data.id}}</b></i>
         </div>
         <div class="col-12 col-md-5 text-start">
             <i>Alias: <b>{{data.alias}}</b></i>
         </div>
         <div class="col-12 col-md-7 text-start text-md-end">
            <i>Provincia: <b>{{data.provinceName}}</b></i>
         </div>
         <div class="col-12 text-start">
            <i>Dirección: <b>{{data.address}}</b></i>
         </div>
      </div>
      <i>Códigos:</i>
      <div class="row border-top">
         <div class="col-12 col-md-6 text-start">
            <i>Selectum: <b>{{ data.sCode }}</b></i>
         </div>
         <div class="col-12 col-md-6 text-start">
             <i>Techmedica: <b>{{data.tCode}}</b></i>
         </div>
      </div>
   </div>
</template>

<script>
import moment from 'moment';

export default {
   props: {
      data: Object
   },
   
   setup() {
      
      function dateTime(dtValue) {
         return moment(dtValue).format('DD-MM-YYYY');
         //return moment(dtValue).format('YYYY-MM-DD HH:mm:ss');
      }
   
   return { dateTime }
   }
   
}
</script>